// src/app/core/interceptors/inflight-dedup.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, shareReplay } from 'rxjs/operators';

@Injectable()
export class InFlightDedupInterceptor implements HttpInterceptor {
  private inFlight = new Map<string, Observable<HttpEvent<any>>>();

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Solo desduplicamos métodos no idempotentes
    if (!['POST', 'PUT', 'PATCH', 'DELETE'].includes(req.method)) {
      return next.handle(req);
    }

    const key = this.makeKey(req);
    const existing = this.inFlight.get(key);
    if (existing) {
      return existing; // <- devolvemos la MISMA respuesta compartida
    }

    const shared$ = next.handle(req).pipe(
      // comparte la misma respuesta con todos los suscriptores
      shareReplay({ bufferSize: 1, refCount: false }),
      // al terminar, liberar la clave
      finalize(() => this.inFlight.delete(key))
    );

    this.inFlight.set(key, shared$);
    return shared$;
  }

  private makeKey(req: HttpRequest<any>): string {
    // normaliza cuerpo para la clave
    const body = typeof req.body === 'string' ? req.body : JSON.stringify(req.body ?? {});
    return `${req.method} ${req.urlWithParams} ${body}`;
  }
}
